// @ts-nocheck
// =============================================================================
//  KitchenControl — HACCP-module
//  Gebruik vanuit de schil: <HaccpModule sb={...} tenantId={...} activeTab={...} onTabChange={...} />
//
//  ✅ FIX: eigen tabbar verwijderd — navigatie loopt via de schil (subItems in zijbalk)
//          activeTab en onTabChange komen binnen als props van App.tsx
// =============================================================================
import { useState, useEffect, useRef } from "react";

// Medewerkers komen uit de centrale Team module
function getTeamMedewerkers() {
  try {
    const s = localStorage.getItem("kc-team-v1");
    if (s) return JSON.parse(s)?.medewerkers || [];
  } catch {}
  return [];
}

// Migreer medewerkers van haccp_config naar Team als Team nog leeg is
function migreerMedewerkers(haccpMeds) {
  if (!haccpMeds?.length) return;
  try {
    const teamData = JSON.parse(localStorage.getItem("kc-team-v1") || "{}");
    if (teamData?.medewerkers?.length) return; // Team heeft al data
    const uid = () => Date.now() + "-" + Math.floor(Math.random() * 9999);
    const nieuw = haccpMeds.map(m => ({ id: m.id || uid(), naam: m.naam }));
    localStorage.setItem("kc-team-v1", JSON.stringify({ medewerkers: nieuw }));
    console.log("[HACCP] Migratie: " + nieuw.length + " medewerkers overgezet naar Team");
  } catch {}
}

let _sb = null;
let _tid = null;
function setBackend(sb, tenantId) {
  _sb = sb;
  _tid = tenantId;
}
const tf = () => (_tid ? `tenant_id=eq.${_tid}&` : "");

async function sbGet(table, params = "") {
  try {
    if (!_sb) return [];
    const d = await _sb.select(table, `${tf()}${params}&order=created_at.desc`);
    return Array.isArray(d) ? d : [];
  } catch {
    return [];
  }
}
async function sbPost(table, body) {
  try {
    if (!_sb) return null;
    const d = await _sb.insert(table, {
      ...(_tid ? { tenant_id: _tid } : {}),
      ...body,
    });
    return Array.isArray(d) ? d[0] : d;
  } catch {
    return null;
  }
}
async function sbPatch(table, id, body) {
  try {
    if (_sb) await _sb.update(table, `id=eq.${id}`, body);
  } catch {}
}
async function sbDelete(table, id) {
  try {
    if (_sb) await _sb.remove(table, `id=eq.${id}`);
  } catch {}
}
async function sbLoadConfig() {
  try {
    if (!_sb) return null;
    const d = await _sb.select(
      "haccp_config",
      `${tf()}select=instellingen&limit=1`
    );
    return d?.[0]?.instellingen || null;
  } catch (e) {
    console.error("HACCP: config laden mislukt —", e);
    return null;
  }
}
async function sbSaveConfig(data) {
  try {
    if (!_sb || !_tid) return false;
    const existing = await _sb.select(
      "haccp_config",
      `${tf()}select=tenant_id&limit=1`
    );
    if (existing?.length) {
      await _sb.update("haccp_config", `tenant_id=eq.${_tid}`, {
        instellingen: data,
        updated_at: new Date().toISOString(),
      });
    } else {
      await _sb.insert("haccp_config", { tenant_id: _tid, instellingen: data });
    }
    return true;
  } catch (e) {
    console.error("HACCP: config opslaan mislukt —", e);
    return false;
  }
}

const ALLERGENEN = [
  "Gluten","Schaaldieren","Eieren","Vis","Pindas","Soja","Melk","Noten",
  "Selderij","Mosterd","Sesamzaad","Zwaveldioxide","Lupine","Weekdieren",
];
const DAYS = ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];
const todayDay = DAYS[new Date().getDay() === 0 ? 6 : new Date().getDay() - 1];
const todayStr = new Date().toLocaleDateString("nl-NL", {
  weekday: "long",
  day: "numeric",
  month: "long",
});
const uid = () => Date.now() + Math.floor(Math.random() * 10000);

// TABS alleen nog als lookup voor de header-titel — geen navigatie meer
const TABS = [
  { id: "schoonmaak", label: "Schoonmaak", icon: "🧹" },
  { id: "temp",       label: "Temperatuur", icon: "🌡" },
  { id: "ontvangst",  label: "Ontvangst",   icon: "📦" },
  { id: "terugkoel",  label: "Terugkoelen", icon: "❄️" },
  { id: "allergen",   label: "Allergenen",  icon: "⚠️" },
  { id: "afwijking",  label: "Afwijkingen", icon: "🚨" },
  { id: "hygiene",    label: "Hygiëne",     icon: "🤒" },
  { id: "instellingen", label: "Instellingen", icon: "⚙️" },
];

const TERUGKOEL_MAX_MIN = 5 * 60;
function duurInMinuten(startTijd, eindTijd) {
  const p = (t) => {
    if (!t || typeof t !== "string" || !t.includes(":")) return null;
    const [h, m] = t.split(":").map((x) => parseInt(x, 10));
    if (isNaN(h) || isNaN(m)) return null;
    return h * 60 + m;
  };
  const s = p(startTijd), e = p(eindTijd);
  if (s === null || e === null) return null;
  let diff = e - s;
  if (diff < 0) diff += 24 * 60;
  return diff;
}
function duurTekst(min) {
  if (min === null || min === undefined) return "";
  return `${Math.floor(min / 60)}u${String(min % 60).padStart(2, "0")}`;
}

const C = {
  bg: "#F8FAFC",
  bg2: "#FFFFFF",
  bg3: "#F1F5F9",
  hdr: "#0F172A",
  hdrBdr: "#1E293B",
  txt: "#0F172A",
  txt2: "#475569",
  txt3: "#94A3B8",
  bdr: "#E2E8F0",
  bdr2: "#CBD5E1",
  primary: "#2563EB",
  primBg: "#EFF6FF",
  primBd: "#BFDBFE",
  gold: "#2563EB",
  goldBg: "#EFF6FF",
  goldBd: "#BFDBFE",
  green: "#16A34A",
  greenBg: "#DCFCE7",
  greenBd: "#BBF7D0",
  red: "#DC2626",
  redBg: "#FEE2E2",
  redBd: "#FCA5A5",
  orange: "#EA580C",
  orangeBg: "#FFEDD5",
  orangeBd: "#FED7AA",
};

const INIT_CONFIG = {
  koelunits: [],
  medewerkers: [],
  leveranciers: [],
  schoonmaakTaken: { dagelijks: [], wekelijks: [], vierweeks: [] },
  allergenenGerechten: [],
};
const mergeCfg = (remote) => ({
  ...INIT_CONFIG,
  ...remote,
  schoonmaakTaken: {
    ...INIT_CONFIG.schoonmaakTaken,
    ...(remote?.schoonmaakTaken || {}),
  },
  koelunits: remote?.koelunits || [],
  medewerkers: remote?.medewerkers || [],
  leveranciers: remote?.leveranciers || [],
  allergenenGerechten: remote?.allergenenGerechten || [],
});

function fmtDate(val, opts) {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d.getTime())) return "";
  return opts
    ? d.toLocaleDateString("nl-NL", opts)
    : d.toLocaleDateString("nl-NL");
}
function fmtTime(val) {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit" });
}

// ════════════════════════════════════════════════════════════════════════
// HACCP MODULE
// Props: sb, tenantId, activeTab (van schil), onTabChange (van schil)
// ════════════════════════════════════════════════════════════════════════
export default function HaccpModule({ sb, tenantId, activeTab, onTabChange }) {
  const [cfg, setCfg] = useState(INIT_CONFIG);
  const [ready, setReady] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [rapportOpen, setRapportOpen] = useState(false);

  // Gebruik activeTab van de schil; als die er nog niet is, val terug op "schoonmaak"
  const tab = activeTab || "schoonmaak";

  setBackend(sb, tenantId);

  useEffect(() => {
    if (!tenantId) return;
    setBackend(sb, tenantId);
    (async () => {
      const remote = await sbLoadConfig();
      if (remote) {
        const merged = mergeCfg(remote);
        setCfg(merged);
        // Migreer medewerkers naar Team als Team nog leeg is
        migreerMedewerkers(merged.medewerkers);
      }
      setReady(true);
    })();
  }, [sb, tenantId]);

  useEffect(() => {
    if (!ready) return;
    setSyncing(true);
    const t = setTimeout(async () => {
      await sbSaveConfig(cfg);
      setSyncing(false);
    }, 1200);
    return () => clearTimeout(t);
  }, [cfg, ready]);

  const updateCfg = (fn) => setCfg((c) => ({ ...c, ...fn(c) }));

  if (!ready)
    return (
      <div
        style={{
          display: "flex",
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
          background: C.bg,
          color: C.txt2,
          fontFamily: "DM Sans, system-ui, sans-serif",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <div style={{ fontSize: 32 }}>🌡️</div>
        <div>HACCP laden…</div>
      </div>
    );

  const activeTabDef = TABS.find((t) => t.id === tab);

  return (
    <div
      className="kc-haccp"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        background: C.bg,
        fontFamily: "DM Sans, system-ui, sans-serif",
        fontSize: 13,
        color: C.txt,
        overflow: "hidden",
      }}
    >
      <style>{CSS}</style>

      {/* ── Header — alleen titel + sync + datum, GEEN tabbar ── */}
      <header
        style={{
          background: C.hdr,
          borderBottom: `1px solid ${C.hdrBdr}`,
          flexShrink: 0,
          height: 52,
          display: "flex",
          alignItems: "center",
          padding: "0 18px",
          gap: 12,
        }}
      >
        <span
          style={{
            fontSize: 15,
            fontWeight: 700,
            color: "#fff",
            letterSpacing: 0.3,
          }}
        >
          {activeTabDef?.icon} {activeTabDef?.label || "HACCP"}
        </span>
        <div style={{ flex: 1 }} />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 11,
            color: syncing ? C.gold : "rgba(255,255,255,.55)",
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: syncing ? C.gold : C.green,
            }}
          />
          {syncing ? "synchroniseren…" : "gesynchroniseerd"}
        </div>
        <button
          onClick={() => setRapportOpen(true)}
          style={{ display: "flex", alignItems: "center", gap: 5, background: "rgba(255,255,255,.12)", border: "1px solid rgba(255,255,255,.2)", color: "#fff", padding: "5px 12px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontFamily: "inherit", fontWeight: 600 }}
        >
          📄 NVWA Rapport
        </button>
        <div style={{ fontSize: 12, color: "rgba(255,255,255,.5)" }}>
          {todayStr}
        </div>
      </header>

      {/* ── NVWA Rapport modal ── */}
      {rapportOpen && (
        <RapportModal
          sb={_sb}
          tenantId={_tid}
          cfg={cfg}
          onClose={() => setRapportOpen(false)}
        />
      )}

      {/* ── Content — geen tabbar meer, direct het scherm ── */}
      <div
        style={{
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {tab === "temp" && <TempTab cfg={cfg} />}
        {tab === "ontvangst" && <OntvangstTab cfg={cfg} updateCfg={updateCfg} />}
        {tab === "terugkoel" && <TerugkoelTab cfg={cfg} />}
        {tab === "schoonmaak" && <SchoonmaakTab cfg={cfg} updateCfg={updateCfg} />}
        {tab === "allergen" && <AllergenenTab cfg={cfg} updateCfg={updateCfg} />}
        {tab === "afwijking" && <AfwijkingTab cfg={cfg} />}
        {tab === "hygiene" && <HygieneTab cfg={cfg} />}
        {tab === "instellingen" && <InstellingenTab cfg={cfg} updateCfg={updateCfg} />}
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// TEMPERATUUR TAB
// ════════════════════════════════════════════════════════════════════════
function TempTab({ cfg }) {
  const [records, setRecords] = useState([]);
  const [form, setForm] = useState({
    unit_id: "",
    unit_naam: "",
    unit_type: "koel",
    temp: "",
    medewerker: "",
    opmerking: "",
  });
  const [loading, setLoading] = useState(true);
  const [activeType, setActiveType] = useState("koel");
  const [attentie, setAttentie] = useState(false);

  useEffect(() => {
    (async () => {
      const d = await sbGet("haccp_temp", "limit=100");
      setRecords(d);
      setLoading(false);
    })();
  }, []);

  const save = async () => {
    if (!form.unit_id || !form.temp || !form.medewerker) return;
    const unit = (cfg.koelunits || []).find(
      (u) => String(u.id) === String(form.unit_id)
    );
    const unitNaam = form.unit_naam || unit?.naam || form.unit_id;
    const unitType = form.unit_type || unit?.type || "koel";
    const tempNum = parseFloat(String(form.temp).replace(",", "."));
    const afwijking = tempIsAfwijking(unitType, tempNum);
    const payload = {
      unit_id: form.unit_id,
      unit_naam: unitNaam,
      unit_type: unitType,
      temp: tempNum,
      norm: unitType === "vriezer" ? -18 : 7,
      afwijking,
      medewerker: form.medewerker,
      opmerking: form.opmerking,
      dag: todayDay,
      created_at: new Date().toISOString(),
    };
    const rec = await sbPost("haccp_temp", payload);
    if (rec) setRecords((r) => [{ ...payload, id: rec.id }, ...r]);
    setForm((f) => ({
      ...f,
      temp: String((f.unit_type || "koel") === "vriezer" ? -18 : 4),
      opmerking: "",
    }));
  };

  const koelunits = (cfg.koelunits || []).filter((u) => u.type === activeType);
  const today = records.filter((r) => r.dag === todayDay);
  const mistUnit = !form.unit_id, mistMedewerker = !form.medewerker;
  const compleet = !mistUnit && !mistMedewerker && !!form.temp;
  useEffect(() => {
    if (compleet && attentie) setAttentie(false);
  }, [compleet, attentie]);

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
      {cfg.koelunits.length === 0 ? (
        <EmptyState icon="🌡️" text="Nog geen koel/vriesunits ingesteld. Ga naar Instellingen om units toe te voegen." />
      ) : (
        <>
          <div style={{ display: "flex", gap: 8 }}>
            {["koel", "vriezer"].map((t) => (
              <button
                key={t}
                onClick={() => {
                  setActiveType(t);
                  setForm((f) => ({
                    ...f,
                    unit_id: "",
                    unit_naam: "",
                    unit_type: t,
                    temp: String(t === "vriezer" ? -18 : 4),
                  }));
                }}
                style={{
                  padding: "6px 16px",
                  fontSize: 12,
                  fontFamily: "inherit",
                  fontWeight: 600,
                  cursor: "pointer",
                  borderRadius: 4,
                  border: `1px solid ${activeType === t ? C.primary : C.bdr}`,
                  background: activeType === t ? C.primBg : C.bg2,
                  color: activeType === t ? C.primary : C.txt2,
                }}
              >
                {t === "koel" ? "🧊 Koeling" : "❄️ Vriezer"}
              </button>
            ))}
          </div>
          <Section title="Nieuwe meting">
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ marginBottom: 4 }}>
                <div style={{ fontSize: 12, color: attentie && mistUnit ? C.red : C.txt2, marginBottom: 8, fontWeight: attentie && mistUnit ? 700 : 400 }}>
                  Unit{attentie && mistUnit ? " — kies een unit" : ""}
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 10,
                    ...(attentie && mistUnit ? { padding: 8, borderRadius: 10, border: `2px solid ${C.red}`, background: C.redBg } : {}),
                  }}
                >
                  {koelunits.map((u) => {
                    const gekozen = String(form.unit_id) === String(u.id);
                    return (
                      <div
                        key={u.id}
                        onClick={() => setForm((f) => ({ ...f, unit_id: u.id, unit_naam: u.naam, unit_type: u.type || "koel", temp: String((u.type || "koel") === "vriezer" ? -18 : 4) }))}
                        style={{
                          padding: 14,
                          borderRadius: 8,
                          cursor: "pointer",
                          border: gekozen ? `2px solid ${C.primary}` : `1px solid ${C.bdr}`,
                          background: gekozen ? C.primBg : C.bg2,
                          transition: "border-color .12s, background .12s",
                        }}
                      >
                        <strong style={{ fontSize: 14, color: C.txt }}>{u.naam}</strong>
                        <div style={{ fontSize: 11, color: C.txt3, marginTop: 3 }}>
                          Norm: {u.type === "vriezer" ? "≤-18°C" : "≤7°C"}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ marginBottom: 4 }}>
                <div style={{ fontSize: 12, color: C.txt2, marginBottom: 8 }}>Temperatuur °C</div>
                <TempStepper
                  type={form.unit_type || activeType}
                  value={form.temp}
                  onChange={(v) => setForm((f) => ({ ...f, temp: v }))}
                />
              </div>
              <FormRow label="Medewerker">
                <MedewerkerSelect cfg={cfg} value={form.medewerker} onChange={(v) => setForm((f) => ({ ...f, medewerker: v }))} error={attentie && mistMedewerker} />
              </FormRow>
              <FormRow label="Opmerking">
                <input style={inputStyle} placeholder="Optioneel…" value={form.opmerking} onChange={(e) => setForm((f) => ({ ...f, opmerking: e.target.value }))} />
              </FormRow>
              <SaveBtn onClick={save} disabled={!compleet} onInvalid={() => setAttentie(true)} />
            </div>
          </Section>
          <Section title={`Metingen vandaag (${today.length})`}>
            {today.length === 0 ? (
              <Empty text="Nog geen metingen vandaag" />
            ) : (
              today.map((r) => (
                <RecordRow
                  key={r.id}
                  afwijking={r.afwijking}
                  left={<><b>{r.unit_naam || "?"}</b> &nbsp;·&nbsp; <span style={{ color: r.afwijking ? C.red : C.green, fontWeight: 700 }}>{r.temp}°C</span></>}
                  right={r.medewerker}
                  sub={`${fmtTime(r.created_at)}${r.afwijking ? " ⚠️ AFWIJKING" : ""}${r.opmerking ? ` · ${r.opmerking}` : ""}`}
                  onDelete={() => { sbDelete("haccp_temp", r.id); setRecords((rs) => rs.filter((x) => x.id !== r.id)); }}
                />
              ))
            )}
          </Section>
          <Section title="Geschiedenis (laatste 50)">
            {loading ? (
              <div style={{ color: C.txt3 }}>Laden…</div>
            ) : (
              records.slice(0, 50).filter((r) => r.dag !== todayDay).map((r) => (
                <RecordRow
                  key={r.id}
                  afwijking={r.afwijking}
                  left={<><b>{r.unit_naam || "?"}</b> &nbsp;·&nbsp; <span style={{ color: r.afwijking ? C.red : C.green, fontWeight: 700 }}>{r.temp}°C</span></>}
                  right={r.medewerker}
                  sub={`${fmtDate(r.created_at)} ${fmtTime(r.created_at)}${r.opmerking ? ` · ${r.opmerking}` : ""}`}
                  onDelete={() => { sbDelete("haccp_temp", r.id); setRecords((rs) => rs.filter((x) => x.id !== r.id)); }}
                />
              ))
            )}
          </Section>
        </>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// ONTVANGST TAB
// ════════════════════════════════════════════════════════════════════════
function OntvangstTab({ cfg, updateCfg }) {
  const [records, setRecords] = useState([]);
  const [form, setForm] = useState({ leverancier: "", product: "", temp: "", tht_ok: null, verpakking_ok: null, medewerker: "", opmerking: "" });
  const [loading, setLoading] = useState(true);
  const [attentie, setAttentie] = useState(false);

  useEffect(() => {
    (async () => {
      const d = await sbGet("haccp_ontvangst", "limit=100");
      setRecords(d);
      setLoading(false);
    })();
  }, []);

  const save = async () => {
    if (!form.leverancier || !form.product || !form.medewerker || !form.temp || form.tht_ok === null || form.verpakking_ok === null) return;
    const tempNum = parseFloat(String(form.temp).replace(",", "."));
    const afwijking = !form.tht_ok || !form.verpakking_ok || (!isNaN(tempNum) && tempNum > 7);
    const naam = form.leverancier.trim();
    const bestaat = (cfg.leveranciers || []).some((l) => l.naam.toLowerCase() === naam.toLowerCase());
    if (naam && !bestaat && updateCfg) updateCfg((c) => ({ leveranciers: [...(c.leveranciers || []), { id: uid(), naam }] }));
    const rec = await sbPost("haccp_ontvangst", { ...form, leverancier: naam, temp: tempNum, afwijking, dag: todayDay, created_at: new Date().toISOString() });
    if (rec) setRecords((r) => [rec, ...r]);
    setForm({ leverancier: "", product: "", temp: "", tht_ok: null, verpakking_ok: null, medewerker: form.medewerker, opmerking: "" });
  };

  const mist = { leverancier: !form.leverancier, product: !form.product, temp: !form.temp, tht: form.tht_ok === null, verpakking: form.verpakking_ok === null, medewerker: !form.medewerker };
  const compleet = !Object.values(mist).some(Boolean);
  useEffect(() => { if (compleet && attentie) setAttentie(false); }, [compleet, attentie]);

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
      <Section title="Ontvangst registreren">
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <FormRow label="Leverancier"><LeverancierSelect cfg={cfg} value={form.leverancier} onChange={(v) => setForm((f) => ({ ...f, leverancier: v }))} error={attentie && mist.leverancier} /></FormRow>
          <FormRow label="Product"><input style={{ ...inputStyle, ...(attentie && mist.product ? { borderColor: C.red, borderWidth: 2, background: C.redBg } : {}) }} placeholder="Productnaam" value={form.product} onChange={(e) => setForm((f) => ({ ...f, product: e.target.value }))} /></FormRow>
          <FormRow label="Temp °C"><TempVrijVeld value={form.temp} onChange={(v) => setForm((f) => ({ ...f, temp: v }))} grens={7} placeholder="bijv. 3.5" error={attentie && mist.temp} /></FormRow>
          <FormRow label="THT/TGT OK"><ToggleBtn value={form.tht_ok} onChange={(v) => setForm((f) => ({ ...f, tht_ok: v }))} error={attentie && mist.tht} /></FormRow>
          <FormRow label="Verpakking OK"><ToggleBtn value={form.verpakking_ok} onChange={(v) => setForm((f) => ({ ...f, verpakking_ok: v }))} error={attentie && mist.verpakking} /></FormRow>
          <FormRow label="Medewerker"><MedewerkerSelect cfg={cfg} value={form.medewerker} onChange={(v) => setForm((f) => ({ ...f, medewerker: v }))} error={attentie && mist.medewerker} /></FormRow>
          <FormRow label="Opmerking"><input style={inputStyle} placeholder="Optioneel…" value={form.opmerking} onChange={(e) => setForm((f) => ({ ...f, opmerking: e.target.value }))} /></FormRow>
          <SaveBtn onClick={save} disabled={!compleet} onInvalid={() => setAttentie(true)} />
        </div>
      </Section>
      <Section title="Registraties (laatste 50)">
        {loading ? <div style={{ color: C.txt3 }}>Laden…</div> : (
          records.slice(0, 50).map((r) => (
            <RecordRow key={r.id} afwijking={r.afwijking}
              left={<><b>{r.leverancier}</b> — {r.product}</>}
              right={r.medewerker}
              sub={`${fmtDate(r.created_at)} · ${r.temp != null ? `${r.temp}°C · ` : ""}THT: ${r.tht_ok ? "✓" : "✗"} · Verpakking: ${r.verpakking_ok ? "✓" : "✗"}${r.opmerking ? ` · ${r.opmerking}` : ""}`}
              onDelete={() => { sbDelete("haccp_ontvangst", r.id); setRecords((rs) => rs.filter((x) => x.id !== r.id)); }}
            />
          ))
        )}
      </Section>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// TERUGKOELEN TAB
// ════════════════════════════════════════════════════════════════════════
function TerugkoelTab({ cfg }) {
  const [records, setRecords] = useState([]);
  const [form, setForm] = useState({ product: "", start_temp: "", eind_temp: "", start_tijd: "", eind_tijd: "", medewerker: "", opmerking: "" });
  const [loading, setLoading] = useState(true);
  const [attentie, setAttentie] = useState(false);

  useEffect(() => {
    (async () => {
      const d = await sbGet("haccp_terugkoel", "limit=100");
      setRecords(d);
      setLoading(false);
    })();
  }, []);

  const save = async () => {
    if (!form.product || !form.medewerker || !form.eind_temp || !form.start_temp || !form.start_tijd || !form.eind_tijd) return;
    const eindNum = parseFloat(String(form.eind_temp).replace(",", "."));
    const startNum = parseFloat(String(form.start_temp).replace(",", "."));
    const duur = duurInMinuten(form.start_tijd, form.eind_tijd);
    const afwijking = eindNum > 7 || (duur !== null && duur > TERUGKOEL_MAX_MIN);
    const rec = await sbPost("haccp_terugkoel", { ...form, eind_temp: eindNum, start_temp: isNaN(startNum) ? null : startNum, duur_min: duur, afwijking, dag: todayDay, created_at: new Date().toISOString() });
    if (rec) setRecords((r) => [rec, ...r]);
    setForm({ product: "", start_temp: "", eind_temp: "", start_tijd: "", eind_tijd: "", medewerker: form.medewerker, opmerking: "" });
  };

  const mist = { product: !form.product, start_temp: !form.start_temp, start_tijd: !form.start_tijd, eind_tijd: !form.eind_tijd, eind_temp: !form.eind_temp, medewerker: !form.medewerker };
  const compleet = !Object.values(mist).some(Boolean);
  useEffect(() => { if (compleet && attentie) setAttentie(false); }, [compleet, attentie]);

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
      <InfoBanner text="Norm: binnen 5 uur terugkoelen tot ≤7°C" />
      <Section title="Terugkoelen registreren">
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <FormRow label="Product"><input style={{ ...inputStyle, ...(attentie && mist.product ? { borderColor: C.red, borderWidth: 2, background: C.redBg } : {}) }} placeholder="Naam product" value={form.product} onChange={(e) => setForm((f) => ({ ...f, product: e.target.value }))} /></FormRow>
          <FormRow label="Starttijd"><input style={{ ...inputStyle, ...(attentie && mist.start_tijd ? { borderColor: C.red, borderWidth: 2, background: C.redBg } : {}) }} type="time" value={form.start_tijd} onChange={(e) => setForm((f) => ({ ...f, start_tijd: e.target.value }))} /></FormRow>
          <FormRow label="Starttemperatuur °C"><input style={{ ...inputStyle, ...(attentie && mist.start_temp ? { borderColor: C.red, borderWidth: 2, background: C.redBg } : {}) }} type="number" step="0.1" placeholder="bijv. 85" value={form.start_temp} onChange={(e) => setForm((f) => ({ ...f, start_temp: e.target.value }))} /></FormRow>
          <FormRow label="Eindtijd"><input style={{ ...inputStyle, ...(attentie && mist.eind_tijd ? { borderColor: C.red, borderWidth: 2, background: C.redBg } : {}) }} type="time" value={form.eind_tijd} onChange={(e) => setForm((f) => ({ ...f, eind_tijd: e.target.value }))} /></FormRow>
          <FormRow label="Eindtemperatuur °C"><TempVrijVeld value={form.eind_temp} onChange={(v) => setForm((f) => ({ ...f, eind_temp: v }))} grens={7} placeholder="moet ≤7°C zijn" error={attentie && mist.eind_temp} /></FormRow>
          <FormRow label="Medewerker"><MedewerkerSelect cfg={cfg} value={form.medewerker} onChange={(v) => setForm((f) => ({ ...f, medewerker: v }))} error={attentie && mist.medewerker} /></FormRow>
          <FormRow label="Opmerking"><input style={inputStyle} placeholder="Optioneel…" value={form.opmerking} onChange={(e) => setForm((f) => ({ ...f, opmerking: e.target.value }))} /></FormRow>
          {(() => {
            const dm = duurInMinuten(form.start_tijd, form.eind_tijd);
            if (dm === null) return null;
            const teLang = dm > TERUGKOEL_MAX_MIN;
            return (
              <div style={{ padding: "8px 12px", borderRadius: 8, fontSize: 12.5, fontWeight: 600, background: teLang ? C.redBg : C.greenBg, border: `1px solid ${teLang ? C.redBd : C.greenBd}`, color: teLang ? C.red : C.green }}>
                Terugkoeltijd: {duurTekst(dm)} {teLang ? "— ✗ langer dan 5 uur (afwijking)" : "— ✓ binnen 5 uur"}
              </div>
            );
          })()}
          <SaveBtn onClick={save} disabled={!compleet} onInvalid={() => setAttentie(true)} />
        </div>
      </Section>
      <Section title="Registraties (laatste 50)">
        {loading ? <div style={{ color: C.txt3 }}>Laden…</div> : (
          records.slice(0, 50).map((r) => {
            const dm = r.duur_min != null ? r.duur_min : duurInMinuten(r.start_tijd, r.eind_tijd);
            const redenen = [];
            if (parseFloat(r.eind_temp) > 7) redenen.push(`te warm: ${r.eind_temp}°C`);
            if (dm != null && dm > TERUGKOEL_MAX_MIN) redenen.push(`te lang: ${duurTekst(dm)}`);
            return (
              <RecordRow key={r.id} afwijking={r.afwijking}
                left={<><b>{r.product}</b></>}
                right={r.medewerker}
                sub={`${fmtDate(r.created_at)} · ${r.start_tijd ? `${r.start_tijd}→` : ""}${r.eind_tijd || ""}${dm != null ? ` (${duurTekst(dm)})` : ""} · Eind: ${r.eind_temp}°C${r.afwijking ? ` ⚠️ AFWIJKING${redenen.length ? ` — ${redenen.join(" · ")}` : ""}` : ""}${r.opmerking ? ` · ${r.opmerking}` : ""}`}
                onDelete={() => { sbDelete("haccp_terugkoel", r.id); setRecords((rs) => rs.filter((x) => x.id !== r.id)); }}
              />
            );
          })
        )}
      </Section>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// SCHOONMAAK TAB
// ════════════════════════════════════════════════════════════════════════
function SchoonmaakTab({ cfg, updateCfg }) {
  const [records, setRecords] = useState([]);
  const [activeFreq, setActiveFreq] = useState("dagelijks");
  const [signForm, setSignForm] = useState({ medewerker: "" });
  const [signAttentie, setSignAttentie] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const d = await sbGet("haccp_schoonmaak", "limit=200");
      setRecords(d);
      setLoading(false);
    })();
  }, []);

  const taken = cfg.schoonmaakTaken?.[activeFreq] || [];

  const isDone = (taak_id) => {
    const now = new Date();
    return records.some((r) => {
      if (r.taak_id !== taak_id) return false;
      const d = new Date(r.created_at);
      if (activeFreq === "dagelijks") return d.toDateString() === now.toDateString();
      const diff = (now - d) / (1000 * 60 * 60 * 24);
      if (activeFreq === "wekelijks") return diff <= 7;
      if (activeFreq === "vierweeks") return diff <= 28;
      return false;
    });
  };

  const isOverdue = (taak_id) => {
    if (isDone(taak_id)) return false;
    const last = records.filter((r) => r.taak_id === taak_id).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
    if (!last) return false;
    const diff = (new Date() - new Date(last.created_at)) / (1000 * 60 * 60 * 24);
    if (activeFreq === "dagelijks") return diff > 1;
    if (activeFreq === "wekelijks") return diff > 7;
    if (activeFreq === "vierweeks") return diff > 28;
    return false;
  };

  const signOff = async (taak) => {
    if (!signForm.medewerker) { setSignAttentie(true); return; }
    const rec = await sbPost("haccp_schoonmaak", { taak_id: taak.id, taak_naam: taak.naam, frequentie: activeFreq, medewerker: signForm.medewerker, dag: todayDay, created_at: new Date().toISOString() });
    if (rec) setRecords((r) => [rec, ...r]);
  };

  const freqs = [
    { id: "dagelijks", label: "Dagelijks" },
    { id: "wekelijks", label: "Wekelijks" },
    { id: "vierweeks", label: "4-wekelijks" },
  ];

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: C.bg2, border: `1px solid ${C.bdr}`, borderRadius: 6 }}>
        <span style={{ fontSize: 12, color: C.txt2, flexShrink: 0 }}>Medewerker:</span>
        <MedewerkerSelect cfg={cfg} value={signForm.medewerker} onChange={(v) => { setSignForm((f) => ({ ...f, medewerker: v })); setSignAttentie(false); }} error={signAttentie && !signForm.medewerker} />
      </div>
      <div style={{ display: "flex", gap: 6 }}>
        {freqs.map((f) => (
          <button key={f.id} onClick={() => setActiveFreq(f.id)} style={{ flex: 1, padding: "7px 8px", fontSize: 11, fontFamily: "inherit", fontWeight: 600, cursor: "pointer", borderRadius: 4, border: `1px solid ${activeFreq === f.id ? C.gold : C.bdr}`, background: activeFreq === f.id ? C.goldBg : C.bg2, color: activeFreq === f.id ? C.gold : C.txt2 }}>
            {f.label}
          </button>
        ))}
      </div>
      {taken.length === 0 ? (
        <EmptyState icon="🧹" text={`Nog geen ${activeFreq}e taken. Voeg ze toe via Instellingen.`} />
      ) : (
        <Section title={`${activeFreq.charAt(0).toUpperCase() + activeFreq.slice(1)}e taken`}>
          {taken.map((taak) => {
            const done = isDone(taak.id), overdue = isOverdue(taak.id);
            const lastRecord = records.filter((r) => r.taak_id === taak.id).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
            return (
              <div key={taak.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: done ? C.greenBg : overdue ? C.redBg : C.bg2, border: `1px solid ${done ? C.greenBd : overdue ? C.redBd : C.bdr}`, borderRadius: 6, marginBottom: 4 }}>
                <span style={{ fontSize: 20, flexShrink: 0 }}>{done ? "✅" : overdue ? "🔴" : "⬜"}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: C.txt }}>{taak.naam}</div>
                  {lastRecord && <div style={{ fontSize: 11, color: C.txt3, marginTop: 2 }}>Laatste: {fmtDate(lastRecord.created_at)} door {lastRecord.medewerker}</div>}
                  {overdue && !done && <div style={{ fontSize: 11, color: C.red, marginTop: 2, fontWeight: 600 }}>⚠️ Termijn verstreken!</div>}
                  {!records.some((r) => r.taak_id === taak.id) && !done && <div style={{ fontSize: 11, color: C.txt3, marginTop: 2 }}>Nog niet uitgevoerd</div>}
                </div>
                {!done && (
                  <button onClick={() => signOff(taak)} style={{ background: C.hdr, border: "none", color: "#fff", padding: "6px 14px", fontSize: 11, fontFamily: "inherit", fontWeight: 600, cursor: "pointer", borderRadius: 4, flexShrink: 0 }}>
                    Afvinken
                  </button>
                )}
              </div>
            );
          })}
        </Section>
      )}
      <Section title="Geschiedenis (laatste 30)">
        {loading ? <div style={{ color: C.txt3 }}>Laden…</div> : (
          records.slice(0, 30).map((r) => (
            <RecordRow key={r.id} afwijking={false}
              left={<><b>{r.taak_naam}</b> — {r.frequentie}</>}
              right={r.medewerker}
              sub={fmtDate(r.created_at, { weekday: "long", day: "numeric", month: "long" })}
              onDelete={() => { sbDelete("haccp_schoonmaak", r.id); setRecords((rs) => rs.filter((x) => x.id !== r.id)); }}
            />
          ))
        )}
      </Section>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// ALLERGENEN TAB
// ════════════════════════════════════════════════════════════════════════
function AllergenenTab({ cfg, updateCfg }) {
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ naam: "", allergenen: [] });
  const [adding, setAdding] = useState(false);
  const gerechten = cfg.allergenenGerechten || [];

  const save = () => {
    if (!form.naam.trim()) return;
    if (editId) {
      updateCfg((c) => ({ allergenenGerechten: c.allergenenGerechten.map((g) => g.id === editId ? { ...g, ...form } : g) }));
      setEditId(null);
    } else {
      updateCfg((c) => ({ allergenenGerechten: [...(c.allergenenGerechten || []), { id: uid(), ...form }] }));
      setAdding(false);
    }
    setForm({ naam: "", allergenen: [] });
  };
  const del = (id) => { if (!confirm("Gerecht verwijderen?")) return; updateCfg((c) => ({ allergenenGerechten: c.allergenenGerechten.filter((g) => g.id !== id) })); };
  const toggleAllergen = (a) => setForm((f) => ({ ...f, allergenen: f.allergenen.includes(a) ? f.allergenen.filter((x) => x !== a) : [...f.allergenen, a] }));
  const startEdit = (g) => { setEditId(g.id); setForm({ naam: g.naam, allergenen: g.allergenen || [] }); setAdding(false); };

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
      <InfoBanner text="Registreer welke van de 14 EU-allergenen in elk gerecht aanwezig zijn." />
      {gerechten.length > 0 && (
        <Section title={`Gerechten (${gerechten.length})`}>
          {gerechten.map((g) => (
            <div key={g.id} style={{ padding: "10px 14px", background: C.bg2, border: `1px solid ${C.bdr}`, borderRadius: 6, marginBottom: 4 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: C.txt }}>{g.naam}</span>
                <div style={{ display: "flex", gap: 6 }}>
                  <button onClick={() => startEdit(g)} style={smallBtn(C.gold, C.goldBg)}>✏</button>
                  <button onClick={() => del(g.id)} style={smallBtn(C.red, C.redBg)}>🗑</button>
                </div>
              </div>
              {g.allergenen?.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {g.allergenen.map((a) => <span key={a} style={{ background: C.redBg, border: `1px solid ${C.redBd}`, color: C.red, fontSize: 10, padding: "2px 8px", borderRadius: 10, fontWeight: 600 }}>{a}</span>)}
                </div>
              ) : <span style={{ fontSize: 11, color: C.txt3 }}>Geen allergenen geregistreerd</span>}
            </div>
          ))}
        </Section>
      )}
      {(adding || editId) && (
        <Section title={editId ? "Gerecht bewerken" : "Nieuw gerecht"}>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <FormRow label="Naam gerecht"><input style={inputStyle} placeholder="Naam" value={form.naam} onChange={(e) => setForm((f) => ({ ...f, naam: e.target.value }))} /></FormRow>
            <div style={{ fontSize: 11, fontWeight: 600, color: C.txt2, marginBottom: 4 }}>Aanwezige allergenen:</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {ALLERGENEN.map((a) => (
                <button key={a} onClick={() => toggleAllergen(a)} style={{ padding: "4px 10px", fontSize: 11, fontFamily: "inherit", cursor: "pointer", borderRadius: 12, border: `1px solid ${form.allergenen.includes(a) ? C.red : C.bdr}`, background: form.allergenen.includes(a) ? C.redBg : C.bg2, color: form.allergenen.includes(a) ? C.red : C.txt2, fontWeight: form.allergenen.includes(a) ? 700 : 400 }}>{a}</button>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
              <button onClick={save} style={{ flex: 1, background: C.gold, border: "none", color: "#fff", padding: 9, fontFamily: "inherit", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 4 }}>💾 Opslaan</button>
              <button onClick={() => { setAdding(false); setEditId(null); setForm({ naam: "", allergenen: [] }); }} style={{ background: C.bg2, border: `1px solid ${C.bdr}`, color: C.txt2, padding: "9px 14px", fontFamily: "inherit", fontSize: 12, cursor: "pointer", borderRadius: 4 }}>Annuleren</button>
            </div>
          </div>
        </Section>
      )}
      {!adding && !editId && (
        <button onClick={() => setAdding(true)} style={{ background: "transparent", border: `1px dashed ${C.bdr2}`, color: C.txt2, padding: "9px 14px", fontFamily: "inherit", fontSize: 12, cursor: "pointer", borderRadius: 4, textAlign: "left" }}>
          + Gerecht toevoegen
        </button>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// AFWIJKINGEN TAB
// ════════════════════════════════════════════════════════════════════════
function AfwijkingTab({ cfg }) {
  const [records, setRecords] = useState([]);
  const [form, setForm] = useState({ omschrijving: "", corrigerende_maatregel: "", medewerker: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const d = await sbGet("haccp_afwijking", "limit=100");
      setRecords(d);
      setLoading(false);
    })();
  }, []);

  const save = async () => {
    if (!form.omschrijving || !form.medewerker) return;
    const rec = await sbPost("haccp_afwijking", { ...form, dag: todayDay, created_at: new Date().toISOString() });
    if (rec) setRecords((r) => [rec, ...r]);
    setForm({ omschrijving: "", corrigerende_maatregel: "", medewerker: form.medewerker });
  };

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
      <Section title="Afwijking registreren">
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <FormRow label="Omschrijving"><textarea style={{ ...inputStyle, minHeight: 70, resize: "vertical" }} placeholder="Beschrijf de afwijking…" value={form.omschrijving} onChange={(e) => setForm((f) => ({ ...f, omschrijving: e.target.value }))} /></FormRow>
          <FormRow label="Corrigerende maatregel"><textarea style={{ ...inputStyle, minHeight: 70, resize: "vertical" }} placeholder="Welke actie is ondernomen?…" value={form.corrigerende_maatregel} onChange={(e) => setForm((f) => ({ ...f, corrigerende_maatregel: e.target.value }))} /></FormRow>
          <FormRow label="Medewerker"><MedewerkerSelect cfg={cfg} value={form.medewerker} onChange={(v) => setForm((f) => ({ ...f, medewerker: v }))} /></FormRow>
          <SaveBtn onClick={save} disabled={!form.omschrijving || !form.medewerker} />
        </div>
      </Section>
      <Section title="Geregistreerde afwijkingen">
        {loading ? <div style={{ color: C.txt3 }}>Laden…</div> : records.length === 0 ? <Empty text="Geen afwijkingen geregistreerd" /> : (
          records.map((r) => (
            <div key={r.id} style={{ padding: "10px 14px", background: C.redBg, border: `1px solid ${C.redBd}`, borderRadius: 6, marginBottom: 4 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span style={{ fontSize: 11, color: C.txt3 }}>{fmtDate(r.created_at)} — {r.medewerker}</span>
                <button onClick={() => { sbDelete("haccp_afwijking", r.id); setRecords((rs) => rs.filter((x) => x.id !== r.id)); }} style={{ background: "none", border: "none", color: C.txt3, cursor: "pointer", fontSize: 12 }}>×</button>
              </div>
              <div style={{ fontSize: 13, color: C.txt, marginBottom: 4 }}><b>Afwijking:</b> {r.omschrijving}</div>
              {r.corrigerende_maatregel && <div style={{ fontSize: 12, color: C.txt2 }}><b>Maatregel:</b> {r.corrigerende_maatregel}</div>}
            </div>
          ))
        )}
      </Section>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// HYGIËNE TAB
// ════════════════════════════════════════════════════════════════════════
function HygieneTab({ cfg }) {
  const [records, setRecords] = useState([]);
  const [form, setForm] = useState({ medewerker: "", klacht: "", thuis_gebleven: false, opmerking: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const d = await sbGet("haccp_hygiene", "limit=100");
      setRecords(d);
      setLoading(false);
    })();
  }, []);

  const save = async () => {
    if (!form.medewerker || !form.klacht) return;
    const rec = await sbPost("haccp_hygiene", { ...form, dag: todayDay, created_at: new Date().toISOString() });
    if (rec) setRecords((r) => [rec, ...r]);
    setForm({ medewerker: "", klacht: "", thuis_gebleven: false, opmerking: "" });
  };

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
      <InfoBanner text="Registreer ziekmeldingen van medewerkers — met name maag/darmklachten." color={C.orangeBg} borderColor={C.orangeBd} textColor={C.orange} />
      <Section title="Ziekmelding registreren">
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <FormRow label="Medewerker"><MedewerkerSelect cfg={cfg} value={form.medewerker} onChange={(v) => setForm((f) => ({ ...f, medewerker: v }))} /></FormRow>
          <FormRow label="Klacht">
            <select style={inputStyle} value={form.klacht} onChange={(e) => setForm((f) => ({ ...f, klacht: e.target.value }))}>
              <option value="">Kies klacht…</option>
              <option>Maag/darmklachten</option>
              <option>Overgeven</option>
              <option>Diarree</option>
              <option>Geelzucht</option>
              <option>Huidinfectie</option>
              <option>Overige klacht</option>
            </select>
          </FormRow>
          <FormRow label="Thuis gebleven"><ToggleBtn value={form.thuis_gebleven} onChange={(v) => setForm((f) => ({ ...f, thuis_gebleven: v }))} /></FormRow>
          <FormRow label="Opmerking"><input style={inputStyle} placeholder="Optioneel…" value={form.opmerking} onChange={(e) => setForm((f) => ({ ...f, opmerking: e.target.value }))} /></FormRow>
          <SaveBtn onClick={save} disabled={!form.medewerker || !form.klacht} />
        </div>
      </Section>
      <Section title="Ziekmeldingen">
        {loading ? <div style={{ color: C.txt3 }}>Laden…</div> : records.length === 0 ? <Empty text="Geen ziekmeldingen geregistreerd" /> : (
          records.map((r) => (
            <RecordRow key={r.id} afwijking={true}
              left={<><b>{r.medewerker}</b> — {r.klacht}</>}
              right={r.thuis_gebleven ? "🏠 thuis" : "👨‍🍳 aanwezig"}
              sub={`${fmtDate(r.created_at)}${r.opmerking ? ` · ${r.opmerking}` : ""}`}
              onDelete={() => { sbDelete("haccp_hygiene", r.id); setRecords((rs) => rs.filter((x) => x.id !== r.id)); }}
            />
          ))
        )}
      </Section>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// INSTELLINGEN TAB
// ════════════════════════════════════════════════════════════════════════
function InstellingenTab({ cfg, updateCfg }) {
  const [newUnit, setNewUnit] = useState({ naam: "", type: "koel" });
  const [newMed, setNewMed] = useState("");
  const [newLev, setNewLev] = useState("");
  const [newTaak, setNewTaak] = useState({ naam: "", freq: "dagelijks" });

  const addUnit = () => { if (!newUnit.naam.trim()) return; updateCfg((c) => ({ koelunits: [...(c.koelunits || []), { id: uid(), ...newUnit }] })); setNewUnit({ naam: "", type: "koel" }); };
  const delUnit = (id) => updateCfg((c) => ({ koelunits: c.koelunits.filter((u) => u.id !== id) }));
  const addMed = () => { if (!newMed.trim()) return; updateCfg((c) => ({ medewerkers: [...(c.medewerkers || []), { id: uid(), naam: newMed.trim() }] })); setNewMed(""); };
  const delMed = (id) => updateCfg((c) => ({ medewerkers: c.medewerkers.filter((m) => m.id !== id) }));
  const addLev = () => { const naam = newLev.trim(); if (!naam) return; if (!(cfg.leveranciers || []).some((l) => l.naam.toLowerCase() === naam.toLowerCase())) updateCfg((c) => ({ leveranciers: [...(c.leveranciers || []), { id: uid(), naam }] })); setNewLev(""); };
  const delLev = (id) => updateCfg((c) => ({ leveranciers: (c.leveranciers || []).filter((l) => l.id !== id) }));
  const addTaak = () => { if (!newTaak.naam.trim()) return; updateCfg((c) => { const taken = { ...(c.schoonmaakTaken || {}) }; taken[newTaak.freq] = [...(taken[newTaak.freq] || []), { id: uid(), naam: newTaak.naam.trim() }]; return { schoonmaakTaken: taken }; }); setNewTaak((t) => ({ ...t, naam: "" })); };
  const delTaak = (freq, id) => updateCfg((c) => { const taken = { ...(c.schoonmaakTaken || {}) }; taken[freq] = taken[freq].filter((t) => t.id !== id); return { schoonmaakTaken: taken }; });

  const lijstRij = (label, onDel) => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", background: C.bg2, border: `1px solid ${C.bdr}`, borderRadius: 6, marginBottom: 4 }}>
      {label}
      <button onClick={onDel} style={smallBtn(C.red, C.redBg)}>🗑</button>
    </div>
  );

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16, display: "flex", flexDirection: "column", gap: 20 }}>
      <Section title="🧊 Koel & vriesunits">
        {(cfg.koelunits || []).map((u) => lijstRij(
          <div><span style={{ fontSize: 13, fontWeight: 600, color: C.txt }}>{u.naam}</span><span style={{ fontSize: 11, color: C.txt3, marginLeft: 8 }}>{u.type === "vriezer" ? "❄️ Vriezer (norm ≤-18°C)" : "🧊 Koeling (norm ≤7°C)"}</span></div>,
          () => delUnit(u.id)
        ))}
        <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
          <input style={{ ...inputStyle, width: "100%" }} placeholder="Naam unit (bijv. Vlees koeling)" value={newUnit.naam} onChange={(e) => setNewUnit((f) => ({ ...f, naam: e.target.value }))} onKeyDown={(e) => e.key === "Enter" && addUnit()} />
          <div style={{ display: "flex", gap: 7 }}>
            <select style={{ ...inputStyle, flex: 1 }} value={newUnit.type} onChange={(e) => setNewUnit((f) => ({ ...f, type: e.target.value }))}>
              <option value="koel">Koeling</option>
              <option value="vriezer">Vriezer</option>
            </select>
            <button onClick={addUnit} style={{ background: C.gold, border: "none", color: "#fff", padding: "8px 20px", fontFamily: "inherit", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 4, flexShrink: 0 }}>+ Toevoegen</button>
          </div>
        </div>
      </Section>

      <Section title="👨‍🍳 Medewerkers">
        <div style={{ padding: "10px 14px", background: C.primBg, border: `1px solid ${C.primBd}`, borderRadius: 6, fontSize: 12, color: C.primary }}>
          Medewerkers worden beheerd via de <strong>Team</strong> module in de zijbalk.
          {getTeamMedewerkers().length > 0
            ? ` ${getTeamMedewerkers().length} medewerkers beschikbaar.`
            : " Voeg medewerkers toe via Team."}
        </div>
      </Section>

      <Section title="🚚 Leveranciers">
        {(cfg.leveranciers || []).map((l) => lijstRij(<span style={{ fontSize: 13, color: C.txt }}>{l.naam}</span>, () => delLev(l.id)))}
        <div style={{ display: "flex", gap: 7, marginTop: 8 }}>
          <input style={{ ...inputStyle, flex: 1 }} placeholder="Naam leverancier (bijv. Sligro)" value={newLev} onChange={(e) => setNewLev(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addLev()} />
          <button onClick={addLev} style={{ background: C.gold, border: "none", color: "#fff", padding: "8px 14px", fontFamily: "inherit", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 4 }}>+</button>
        </div>
      </Section>

      <Section title="🧹 Schoonmaaktaken">
        {["dagelijks", "wekelijks", "vierweeks"].map((freq) => (
          <div key={freq} style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.txt2, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>
              {freq === "vierweeks" ? "4-wekelijks" : freq.charAt(0).toUpperCase() + freq.slice(1)}
            </div>
            {(cfg.schoonmaakTaken?.[freq] || []).map((t) => lijstRij(<span style={{ fontSize: 12, color: C.txt }}>{t.naam}</span>, () => delTaak(freq, t.id)))}
          </div>
        ))}
        <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 4 }}>
          <input style={{ ...inputStyle, width: "100%" }} placeholder="Nieuwe taak (bijv. Vloer keuken vegen)" value={newTaak.naam} onChange={(e) => setNewTaak((f) => ({ ...f, naam: e.target.value }))} onKeyDown={(e) => e.key === "Enter" && addTaak()} />
          <div style={{ display: "flex", gap: 7 }}>
            <select style={{ ...inputStyle, flex: 1 }} value={newTaak.freq} onChange={(e) => setNewTaak((f) => ({ ...f, freq: e.target.value }))}>
              <option value="dagelijks">Dagelijks</option>
              <option value="wekelijks">Wekelijks</option>
              <option value="vierweeks">4-wekelijks</option>
            </select>
            <button onClick={addTaak} style={{ background: C.gold, border: "none", color: "#fff", padding: "8px 20px", fontFamily: "inherit", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 4, flexShrink: 0 }}>+ Toevoegen</button>
          </div>
        </div>
      </Section>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════
// GEDEELDE HELPERS
// ════════════════════════════════════════════════════════════════════════
const inputStyle = {
  background: "#FFFFFF",
  border: `1px solid ${C.bdr}`,
  color: "#0F172A",
  padding: "7px 10px",
  fontFamily: "DM Sans, sans-serif",
  fontSize: 12,
  outline: "none",
  borderRadius: 4,
  width: "100%",
  boxSizing: "border-box",
  WebkitTextFillColor: "#0F172A",
};
const smallBtn = (color, bg) => ({
  background: bg,
  border: `1px solid ${color}22`,
  color,
  padding: "4px 8px",
  fontSize: 11,
  fontFamily: "inherit",
  cursor: "pointer",
  borderRadius: 4,
});

function Section({ title, children }) {
  return (
    <div>
      <div style={{ fontSize: 10, fontWeight: 700, color: C.txt2, textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 8 }}>{title}</div>
      {children}
    </div>
  );
}
function FormRow({ label, children }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "130px 1fr", alignItems: "center", gap: 8 }}>
      <span style={{ fontSize: 12, color: C.txt2, fontWeight: 500 }}>{label}</span>
      {children}
    </div>
  );
}
function SaveBtn({ onClick, disabled, onInvalid }) {
  return (
    <button
      onClick={() => { if (disabled) { onInvalid && onInvalid(); } else onClick(); }}
      style={{ background: disabled ? C.bdr : C.primary, border: "none", color: disabled ? C.txt3 : "#fff", padding: "9px 14px", fontFamily: "DM Sans, inherit", fontSize: 12, fontWeight: 700, cursor: disabled ? "not-allowed" : "pointer", borderRadius: 4, marginTop: 4 }}
    >
      💾 Opslaan
    </button>
  );
}
function MedewerkerSelect({ cfg, value, onChange, error }) {
  // Lees medewerkers uit centrale Team module, val terug op cfg.medewerkers
  const teamMeds = getTeamMedewerkers();
  const lijst = teamMeds.length > 0 ? teamMeds : (cfg?.medewerkers || []);
  return (
    <select style={{ ...inputStyle, ...(error ? { borderColor: C.red, borderWidth: 2, background: C.redBg } : {}) }} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">Kies medewerker…</option>
      {lijst.map((m) => <option key={m.id} value={m.naam}>{m.naam}</option>)}
    </select>
  );
}
function LeverancierSelect({ cfg, value, onChange, error }) {
  const lijst = cfg.leveranciers || [];
  const [nieuw, setNieuw] = useState(false);
  const errStyle = error ? { borderColor: C.red, borderWidth: 2, background: C.redBg } : {};
  if (nieuw || lijst.length === 0)
    return (
      <div style={{ display: "flex", gap: 6 }}>
        <input style={{ ...inputStyle, flex: 1, ...errStyle }} placeholder="Naam nieuwe leverancier" value={value} onChange={(e) => onChange(e.target.value)} autoFocus={nieuw} />
        {lijst.length > 0 && <button onClick={() => { setNieuw(false); onChange(""); }} style={{ ...inputStyle, width: "auto", padding: "0 12px", cursor: "pointer", background: C.bg3, color: C.txt2, fontWeight: 600, flexShrink: 0 }} title="Terug naar lijst">↩</button>}
      </div>
    );
  return (
    <select style={{ ...inputStyle, ...errStyle }} value={value} onChange={(e) => { if (e.target.value === "__nieuw__") { setNieuw(true); onChange(""); } else onChange(e.target.value); }}>
      <option value="">Kies leverancier…</option>
      {lijst.map((l) => <option key={l.id} value={l.naam}>{l.naam}</option>)}
      <option value="__nieuw__">+ Nieuwe leverancier…</option>
    </select>
  );
}
function tempIsAfwijking(type, t) {
  if (t === null || t === undefined || t === "" || isNaN(t)) return false;
  return type === "vriezer" ? parseFloat(t) > -18 : parseFloat(t) > 7;
}
function tempKleur(type, t, C) {
  return tempIsAfwijking(type, t) ? { bg: C.redBg, bd: C.redBd, fg: C.red } : { bg: C.greenBg, bd: C.greenBd, fg: C.green };
}
function TempStepper({ type, value, onChange }) {
  const start = type === "vriezer" ? -18 : 4;
  const huidig = value === "" || value === null || value === undefined ? start : Math.round(parseFloat(value));
  const k = tempKleur(type, huidig, C);
  const tik = (d) => onChange(String(huidig + d));
  const knop = (label, d) => (
    <button onClick={() => tik(d)} onTouchEnd={(e) => { e.preventDefault(); tik(d); }} style={{ width: 60, height: 60, flexShrink: 0, borderRadius: 12, border: `1px solid ${C.primBd}`, background: C.primBg, color: C.primary, fontSize: 28, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", WebkitTapHighlightColor: "transparent", userSelect: "none" }}>{label}</button>
  );
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, width: "100%" }}>
      {knop("−", -1)}
      <div style={{ flex: 1, textAlign: "center", padding: "10px 8px", borderRadius: 10, background: k.bg, border: `1px solid ${k.bd}`, color: k.fg }}>
        <span style={{ fontSize: 32, fontWeight: 800 }}>{huidig}</span>
        <span style={{ fontSize: 16, marginLeft: 2 }}>°C</span>
        <div style={{ fontSize: 11, fontWeight: 700, marginTop: 2 }}>{tempIsAfwijking(type, huidig) ? "✗ afwijking" : "✓ binnen norm"}</div>
      </div>
      {knop("+", 1)}
    </div>
  );
}
function TempVrijVeld({ value, onChange, grens = 7, placeholder = "bijv. 4.5", error }) {
  const heeft = value !== "" && value !== null && value !== undefined;
  const num = heeft ? parseFloat(String(value).replace(",", ".")) : null;
  const afw = num !== null && !isNaN(num) && num > grens;
  const k = error && !heeft ? { bg: C.redBg, bd: C.red, fg: C.red } : !heeft ? { bg: C.bg2, bd: C.bdr, fg: C.txt } : afw ? { bg: C.redBg, bd: C.redBd, fg: C.red } : { bg: C.greenBg, bd: C.greenBd, fg: C.green };
  return (
    <input type="number" step="0.1" placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} style={{ ...inputStyle, background: k.bg, borderColor: k.bd, borderWidth: error && !heeft ? 2 : 1, color: k.fg, fontWeight: heeft ? 700 : 400 }} />
  );
}
function ToggleBtn({ value, onChange, error }) {
  const next = value === null ? true : value === true ? false : true;
  const isNull = value === null || value === undefined;
  const attentieRand = error && isNull;
  return (
    <button
      onClick={() => onChange(next)}
      onTouchEnd={(e) => { e.preventDefault(); onChange(next); }}
      style={{ padding: "6px 16px", fontSize: 12, fontFamily: "inherit", fontWeight: 700, cursor: "pointer", borderRadius: 4, border: attentieRand ? `2px solid ${C.red}` : `1px solid ${isNull ? C.bdr2 : value ? C.greenBd : C.redBd}`, background: attentieRand ? C.redBg : isNull ? C.bg3 : value ? C.greenBg : C.redBg, color: attentieRand ? C.red : isNull ? C.txt3 : value ? C.green : C.red, WebkitTapHighlightColor: "transparent" }}
    >
      {isNull ? "Ja / Nee?" : value ? "✓ Ja" : "✗ Nee"}
    </button>
  );
}
function RecordRow({ left, right, sub, afwijking, onDelete }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gridTemplateRows: "auto auto", padding: "9px 12px", background: afwijking ? C.redBg : C.bg2, border: `1px solid ${afwijking ? C.redBd : C.bdr}`, borderLeft: `3px solid ${afwijking ? C.red : C.greenBd}`, borderRadius: 6, marginBottom: 3, gap: "2px 10px" }}>
      <span style={{ fontSize: 13, color: C.txt }}>{left}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 11, color: C.txt2 }}>{right}</span>
        <button onClick={onDelete} style={{ background: "none", border: "none", color: C.txt3, cursor: "pointer", fontSize: 13, padding: 0, lineHeight: 1 }}>×</button>
      </div>
      <span style={{ fontSize: 11, color: C.txt3, gridColumn: "1/3" }}>{sub}</span>
    </div>
  );
}
function InfoBanner({ text, color = "rgba(37,99,235,.08)", borderColor = "rgba(37,99,235,.25)", textColor = C.txt2 }) {
  return (
    <div style={{ padding: "10px 14px", background: color, border: `1px solid ${borderColor}`, borderRadius: 6, fontSize: 12, color: textColor }}>
      ℹ️ {text}
    </div>
  );
}
function EmptyState({ icon, text }) {
  return (
    <div style={{ padding: "50px 20px", textAlign: "center", color: C.txt3 }}>
      <div style={{ fontSize: 36, marginBottom: 12 }}>{icon}</div>
      <p style={{ fontSize: 13 }}>{text}</p>
    </div>
  );
}
function Empty({ text }) {
  return <div style={{ padding: "16px 0", fontSize: 12, color: C.txt3, fontStyle: "italic" }}>{text}</div>;
}

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
  .kc-haccp, .kc-haccp * { font-family: 'DM Sans', system-ui, sans-serif; box-sizing: border-box; }
  .kc-haccp input, .kc-haccp textarea, .kc-haccp select { background:#FFFFFF; color:#0F172A; -webkit-text-fill-color:#0F172A; }
  .kc-haccp input:focus, .kc-haccp textarea:focus, .kc-haccp select:focus { border-color:#2563EB; box-shadow:0 0 0 2px rgba(37,99,235,0.15); }
  .kc-haccp ::-webkit-scrollbar { width:5px; height:5px; }
  .kc-haccp ::-webkit-scrollbar-track { background:#F8FAFC; }
  .kc-haccp ::-webkit-scrollbar-thumb { background:#E2E8F0; border-radius:3px; }
`;

// =============================================================================
// NVWA RAPPORT MODAL
// =============================================================================
function RapportModal({ sb, tenantId, cfg, onClose }) {
  const now = new Date();
  const mon = new Date(now);
  mon.setDate(now.getDate() - (now.getDay() === 0 ? 6 : now.getDay() - 1));
  const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
  const fmt = d => d.toISOString().slice(0, 10);

  const [van, setVan] = useState(fmt(mon));
  const [tot, setTot] = useState(fmt(sun));
  const [laden, setLaden] = useState(false);
  const [fout, setFout] = useState("");

  const genereer = async () => {
    if (!van || !tot) { setFout("Kies een van- en tot-datum."); return; }
    if (van > tot) { setFout("Van-datum moet voor tot-datum liggen."); return; }
    setFout("");
    setLaden(true);

    try {
      const vanISO = `${van}T00:00:00.000Z`;
      const totISO = `${tot}T23:59:59.999Z`;
      const tid = tenantId ? `tenant_id=eq.${tenantId}&` : "";

      const [temp, ontvangst, terugkoel, schoonmaak, afwijking, hygiene] = await Promise.all([
        sb.select("haccp_temp",       `${tid}created_at=gte.${vanISO}&created_at=lte.${totISO}&order=created_at.asc&limit=500`),
        sb.select("haccp_ontvangst",  `${tid}created_at=gte.${vanISO}&created_at=lte.${totISO}&order=created_at.asc&limit=500`),
        sb.select("haccp_terugkoel",  `${tid}created_at=gte.${vanISO}&created_at=lte.${totISO}&order=created_at.asc&limit=500`),
        sb.select("haccp_schoonmaak", `${tid}created_at=gte.${vanISO}&created_at=lte.${totISO}&order=created_at.asc&limit=500`),
        sb.select("haccp_afwijking",  `${tid}created_at=gte.${vanISO}&created_at=lte.${totISO}&order=created_at.asc&limit=500`),
        sb.select("haccp_hygiene",    `${tid}created_at=gte.${vanISO}&created_at=lte.${totISO}&order=created_at.asc&limit=500`),
      ]);

      const bedrijf = cfg?.bedrijfsnaam || "KitchenControl";
      const datumBereik = `${van} t/m ${tot}`;

      const fmtD = s => { if (!s) return ""; const d = new Date(s); return isNaN(d) ? s : d.toLocaleDateString("nl-NL"); };
      const fmtT = s => { if (!s) return ""; const d = new Date(s); return isNaN(d) ? s : d.toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit" }); };
      const fmtDT = s => { if (!s) return ""; return `${fmtD(s)} ${fmtT(s)}`; };
      const afw = v => v ? '<span class="afw">⚠ AFWIJKING</span>' : '<span class="ok">✓</span>';

      // sectie(titel, headers, htmlRijen) — htmlRijen is array van <td>...</td> strings
      const sectie = (titel, headers, htmlRijen) => {
        if (!htmlRijen?.length) return "";
        return `
          <div class="sectie">
            <h2>${titel} <span class="count">(${htmlRijen.length})</span></h2>
            <table>
              <thead><tr>${headers.map(h => `<th>${h}</th>`).join("")}</tr></thead>
              <tbody>${htmlRijen.map(r => `<tr>${r}</tr>`).join("")}</tbody>
            </table>
          </div>`;
      };

      const tempRijen = (temp || []).map(r => `
        <td>${fmtD(r.created_at)}</td>
        <td>${fmtT(r.created_at)}</td>
        <td>${r.unit_naam || ""}</td>
        <td>${r.unit_type || ""}</td>
        <td><strong>${r.temp}°C</strong></td>
        <td>${r.unit_type === "vriezer" ? "≤-18°C" : "≤7°C"}</td>
        <td>${r.medewerker || ""}</td>
        <td>${r.opmerking || ""}</td>
        <td>${afw(r.afwijking)}</td>
      `);

      const ontvangstRijen = (ontvangst || []).map(r => `
        <td>${fmtD(r.created_at)}</td>
        <td>${r.leverancier || ""}</td>
        <td>${r.product || ""}</td>
        <td>${r.temp != null ? r.temp + "°C" : ""}</td>
        <td>${r.tht_ok ? "✓" : "✗"}</td>
        <td>${r.verpakking_ok ? "✓" : "✗"}</td>
        <td>${r.medewerker || ""}</td>
        <td>${r.opmerking || ""}</td>
        <td>${afw(r.afwijking)}</td>
      `);

      const terugkoelRijen = (terugkoel || []).map(r => {
        const dm = r.duur_min;
        const duur = dm != null ? `${Math.floor(dm/60)}u${String(dm%60).padStart(2,"0")}` : "";
        return `
          <td>${fmtD(r.created_at)}</td>
          <td>${r.product || ""}</td>
          <td>${r.start_tijd || ""}</td>
          <td>${r.eind_tijd || ""}</td>
          <td>${duur}</td>
          <td><strong>${r.eind_temp}°C</strong></td>
          <td>${r.medewerker || ""}</td>
          <td>${r.opmerking || ""}</td>
          <td>${afw(r.afwijking)}</td>
        `;
      });

      const schoonmaakRijen = (schoonmaak || []).map(r => `
        <td>${fmtD(r.created_at)}</td>
        <td>${r.taak_naam || ""}</td>
        <td>${r.frequentie || ""}</td>
        <td>${r.medewerker || ""}</td>
      `);

      const afwijkingRijen = (afwijking || []).map(r => `
        <td>${fmtD(r.created_at)}</td>
        <td>${r.omschrijving || ""}</td>
        <td>${r.corrigerende_maatregel || ""}</td>
        <td>${r.medewerker || ""}</td>
      `);

      const hygieneRijen = (hygiene || []).map(r => `
        <td>${fmtD(r.created_at)}</td>
        <td>${r.medewerker || ""}</td>
        <td>${r.klacht || ""}</td>
        <td>${r.thuis_gebleven ? "Ja" : "Nee"}</td>
        <td>${r.opmerking || ""}</td>
      `);

      const html = `<!DOCTYPE html>
<html lang="nl">
<head>
  <meta charset="utf-8">
  <title>HACCP Rapport – ${datumBereik}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: system-ui, -apple-system, sans-serif; font-size: 11pt; color: #0F172A; padding: 15mm 15mm 20mm; }
    h1 { font-size: 18pt; font-weight: 800; margin-bottom: 4px; }
    .meta { font-size: 10pt; color: #475569; margin-bottom: 6px; }
    .periode { font-size: 10pt; color: #2563EB; font-weight: 600; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 2px solid #0F172A; }
    .sectie { margin-bottom: 24px; page-break-inside: avoid; }
    h2 { font-size: 12pt; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px solid #CBD5E1; color: #334155; }
    .count { font-size: 9pt; font-weight: 400; color: #94A3B8; }
    table { width: 100%; border-collapse: collapse; font-size: 9.5pt; }
    th { background: #F1F5F9; padding: 5px 8px; text-align: left; font-weight: 700; border: 1px solid #E2E8F0; font-size: 9pt; }
    td { padding: 4px 8px; border: 1px solid #E2E8F0; vertical-align: top; }
    tr:nth-child(even) td { background: #F8FAFC; }
    .afw { color: #DC2626; font-weight: 700; }
    .ok { color: #16A34A; }
    .leeg { font-size: 10pt; color: #94A3B8; font-style: italic; padding: 8px 0; }
    .footer { margin-top: 30px; padding-top: 10px; border-top: 1px solid #CBD5E1; font-size: 9pt; color: #94A3B8; display: flex; justify-content: space-between; }
    .print-hint { background: #EFF6FF; border: 1px solid #BFDBFE; color: #1D4ED8; padding: 10px 14px; border-radius: 6px; font-size: 10pt; margin-bottom: 16px; }
    @media print { .print-hint { display: none !important; } }
    @page { margin: 15mm; }
    @media print { body { padding: 0; } }
  </style>
</head>
<body>
  <div class="print-hint">
    💡 Kies <strong>"Opslaan als PDF"</strong> als printer om het rapport op te slaan.
    Zet indien nodig <strong>"Achtergrondafbeeldingen"</strong> aan voor de opmaak.
  </div>
  <h1>HACCP Registratierapport</h1>
  <div class="meta">${bedrijf}</div>
  <div class="periode">Periode: ${datumBereik}</div>

  ${sectie("&#127777; Temperatuurmetingen", ["Datum", "Tijdstip", "Unit", "Type", "Temperatuur", "Norm", "Medewerker", "Opmerking", "Status"], tempRijen)}
  ${sectie("&#128230; Ontvangst", ["Datum", "Leverancier", "Product", "Temp", "THT OK", "Verpakking OK", "Medewerker", "Opmerking", "Status"], ontvangstRijen)}
  ${sectie("&#10052; Terugkoelen", ["Datum", "Product", "Starttijd", "Eindtijd", "Duur", "Eindtemp", "Medewerker", "Opmerking", "Status"], terugkoelRijen)}
  ${sectie("&#10024; Schoonmaak", ["Datum", "Taak", "Frequentie", "Medewerker"], schoonmaakRijen)}
  ${sectie("&#128680; Afwijkingen", ["Datum", "Omschrijving", "Corrigerende maatregel", "Medewerker"], afwijkingRijen)}
  ${sectie("&#129516; Hygiene / Ziekmeldingen", ["Datum", "Medewerker", "Klacht", "Thuis gebleven", "Opmerking"], hygieneRijen)}

  <div class="footer">
    <span>Gegenereerd op ${new Date().toLocaleString("nl-NL")}</span>
    <span>${bedrijf} — KitchenControl HACCP</span>
  </div>

  <script>window.onload = function() { window.print(); }<\/script>
</body>
</html>`;

      const win = window.open("", "_blank", "width=900,height=700");
      if (win) { win.document.write(html); win.document.close(); }
      onClose();
    } catch (e) {
      setFout(`Fout bij ophalen data: ${e.message}`);
    } finally {
      setLaden(false);
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: C.bg2, borderRadius: 12, width: "100%", maxWidth: 440, boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", padding: "16px 20px", borderBottom: `1px solid ${C.bdr}` }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: C.txt, flex: 1 }}>📄 NVWA Rapport genereren</span>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: C.txt3, fontSize: 18, padding: 4 }}>✕</button>
        </div>

        {/* Body */}
        <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 14 }}>
          <p style={{ fontSize: 12, color: C.txt2, lineHeight: 1.6 }}>
            Genereer een overzicht van alle HACCP-registraties in de gekozen periode.
            Lege secties worden weggelaten. Het rapport opent als printbaar PDF-venster.
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: C.txt2, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 5 }}>Van</label>
              <input type="date" value={van} onChange={e => setVan(e.target.value)}
                style={{ background: C.bg2, border: `1px solid ${C.bdr}`, color: C.txt, padding: "7px 10px", fontFamily: "inherit", fontSize: 13, borderRadius: 6, outline: "none", width: "100%" }} />
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: C.txt2, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 5 }}>Tot</label>
              <input type="date" value={tot} onChange={e => setTot(e.target.value)}
                style={{ background: C.bg2, border: `1px solid ${C.bdr}`, color: C.txt, padding: "7px 10px", fontFamily: "inherit", fontSize: 13, borderRadius: 6, outline: "none", width: "100%" }} />
            </div>
          </div>

          {fout && (
            <div style={{ padding: "8px 12px", background: C.redBg, border: `1px solid ${C.redBd}`, borderRadius: 6, fontSize: 12, color: C.red }}>{fout}</div>
          )}

          <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
            <button onClick={genereer} disabled={laden}
              style={{ flex: 1, background: laden ? C.bdr : C.pri, border: "none", color: laden ? C.txt3 : "#fff", padding: "10px 14px", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: laden ? "not-allowed" : "pointer", borderRadius: 6 }}>
              {laden ? "⏳ Laden…" : "📄 Rapport genereren"}
            </button>
            <button onClick={onClose}
              style={{ background: C.bg3, border: `1px solid ${C.bdr}`, color: C.txt2, padding: "10px 14px", fontFamily: "inherit", fontSize: 12, cursor: "pointer", borderRadius: 6 }}>
              Annuleren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
